module.exports = __webpack_public_path__ + "static/media/green-leaf-bg.975bddb5.svg";